export default {"src":"/_next/static/media/arrow_black.3d801381.svg","height":10,"width":16};